<span class="goback">
  <a href="" class="btn btn-grey-bg" (click)="goBack($event)">
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M0.224124 8.5555C-0.0747085 8.2456 -0.0747085 7.75479 0.224124 7.44489L6.39555 1.04488C6.70224 0.726837 7.20869 0.717629 7.52674 1.02432C7.84478 1.33101 7.85399 1.83746 7.5473 2.1555L2.68278 7.20019L15.2 7.20019C15.6418 7.20019 16 7.55837 16 8.00019C16 8.44202 15.6418 8.80019 15.2 8.80019L2.68278 8.80019L7.5473 13.8449C7.85399 14.1629 7.84478 14.6694 7.52674 14.9761C7.20869 15.2828 6.70224 15.2735 6.39555 14.9555L0.224124 8.5555Z" fill="black"/>
    </svg> Go Back
  </a>
</span>
<div *ngIf="page == 1" class="wrap-comapny-nosearch-result">
  <div class="top-wrap-sec">
    <div class="textwrap">
      <h6 class="sec-title">The company you are trying to access does not exist with us at the moment</h6>
      <p>Please share the details below and our team will update you on this</p>
    </div>
    <div class="wrap-img">
      <p class="companyname">{{ newCompanyName }}</p>
      <img src="assets/images/nosearch-result.svg" class="search-result-img" />
    </div>
  </div>
  <div class="form-wrap">
    <form class="form-wrapper" id="newCompanyForm" [formGroup]="newCompanyForm">
      <div class="field-group">
        <div class="form-outline mb-3">
          <label class="form-label">Company Name</label>
          <input type="text" id="company_name" formControlName="company_name" class="form-control" placeholder="XYZ Company" />
          <div *ngIf="
              newCompanyForm.controls['company_name'].touched &&
              newCompanyForm.controls['company_name'].invalid
            " class="alert alert-danger form-danger error" role="alert">
            <span *ngIf="newCompanyForm.controls.company_name.errors.required">Company Name is required.</span>
          </div>
        </div>

        <div class="form-outline mb-3">
          <label class="form-label">Website</label>
          <input type="text" id="website" formControlName="website" class="form-control" placeholder="example.com"/>
          <div *ngIf="
              newCompanyForm.controls['website'].touched &&
              newCompanyForm.controls['website'].invalid
            " class="alert alert-danger form-danger error" role="alert">
            <span *ngIf="newCompanyForm.controls.website.errors.required">Website is required.</span>
            <span *ngIf="newCompanyForm?.controls.website.errors?.url">Please Enter a valid URL</span>
          </div>
        </div>

        <div class="form-outline mb-3">
          <label class="form-label">Cin (Optional)</label>
          <input type="text" id="cin" formControlName="cin" class="form-control" placeholder="enter here"/>
          <div *ngIf="
              newCompanyForm.controls['cin'].touched &&
              newCompanyForm.controls['cin'].invalid
            " class="alert alert-danger form-danger error" role="alert">
            <span *ngIf="newCompanyForm?.controls['cin']?.errors?.noWhiteSpace">Please remove extra spaces.</span>
            <span *ngIf="newCompanyForm?.controls['cin']?.errors?.maxlength">CIN must be 21 letters long.</span>
            <span *ngIf="newCompanyForm?.controls['cin']?.errors?.minlength">CIN must be 21 letters long.</span>
          </div>
        </div>

        <div class="form-outline mb-3">
          <label class="form-label">Your Full Name</label>
          <input type="name" id="name" formControlName="name" class="form-control" placeholder="eg. John Doe"/>
          <div *ngIf="
              newCompanyForm.controls['name'].touched &&
              newCompanyForm.controls['name'].invalid
            " class="alert alert-danger form-danger error" role="alert">
            <span *ngIf="newCompanyForm.controls.name.errors.required">Name is required.</span>
            <span *ngIf="
                newCompanyForm.controls.name.errors.minlength &&
                !newCompanyForm.controls.name.errors.required
              ">Please enter minimum 3 character long name.</span>
            <span *ngIf="
                newCompanyForm.controls.name.errors.maxlength &&
                !newCompanyForm.controls.name.errors.required
              ">Please enter maximum 20 character long name.</span>
          </div>
        </div>
        <div class="form-outline mb-3">
          <label class="form-label">Email Address</label>
          <input type="email" id="email" formControlName="email" class="form-control" placeholder="abc@example.com"/>
          <div *ngIf="
              newCompanyForm.controls['email'].touched &&
              newCompanyForm.controls['email'].invalid
            " class="alert alert-danger form-danger error" role="alert">
            <span *ngIf="newCompanyForm.controls.name.errors.required">Email is required.</span>
            <span *ngIf="
                newCompanyForm.controls.email.errors.email ||
                newCompanyForm.controls.email.errors.required
              ">Please provide valid email address.</span>
          </div>
        </div>
      </div>
      <button *ngIf="isNCR == false" type="submit" class="btn btn-dark-blue-bg submit-button" (click)="submit()"
        [disabled]="!newCompanyForm.valid">
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M13.7733 2.32695C13.4693 2.02436 12.9751 2.02436 12.6711 2.32695L4.92593 10.0364L1.3289 6.45599C1.0249 6.15339 0.530657 6.15339 0.226657 6.45599C-0.0755523 6.7568 -0.0755525 7.24321 0.226657 7.54402L4.37481 11.6731C4.67881 11.9757 5.17305 11.9757 5.47705 11.6731L13.7733 3.41499C14.0756 3.11418 14.0756 2.62777 13.7733 2.32695Z" fill="white"/>
        </svg>
        Submit
      </button>
      <span  *ngIf="isNCR == true" class="price-tag">₹ 1999</span><br/><br/>
      <button *ngIf="isNCR == true" type="submit" class="btn btn-dark-blue-bg submit-button" (click)="submit()"
      [disabled]="!newCompanyForm.valid">
      Add to Cart
      </button>
    </form>
    <div class="note-text">
      <p>Note: Once you submit the requirement we’ll process the information and update the company report on our portal and
      same will be emailed to you within 4-5 business days.<br/>
      If there’s any unclear requirement our team will reach out to you.</p>
      <p>For any confusion please contact us at <span>support&#64;thekredible.in</span></p>
    </div>
  </div>
  <!-- <div class="row">
    <div class="col-12 col-md-5">

      <div class="offerlist-wrap">
        <h2>What we offer</h2>
        <ul class="listwrap">
          <li class="itemlist">
            <svg width="19" height="14" viewBox="0 0 19 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M18.7218 0.278264C18.3508 -0.0927548 17.7493 -0.0927548 17.3782 0.278264L5.99666 11.66L1.62177 7.28506C1.25079 6.91404 0.64932 6.91408 0.278264 7.28506C-0.0927548 7.65604 -0.0927548 8.25751 0.278264 8.62853L5.32491 13.6751C5.69578 14.0461 6.29769 14.0458 6.66842 13.6751L18.7218 1.62177C19.0928 1.25079 19.0927 0.649283 18.7218 0.278264Z"
                fill="#0066FF" />
            </svg>
            <span class="text">Funding History</span>
          </li>
          <li class="itemlist">
            <svg width="19" height="14" viewBox="0 0 19 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M18.7218 0.278264C18.3508 -0.0927548 17.7493 -0.0927548 17.3782 0.278264L5.99666 11.66L1.62177 7.28506C1.25079 6.91404 0.64932 6.91408 0.278264 7.28506C-0.0927548 7.65604 -0.0927548 8.25751 0.278264 8.62853L5.32491 13.6751C5.69578 14.0461 6.29769 14.0458 6.66842 13.6751L18.7218 1.62177C19.0928 1.25079 19.0927 0.649283 18.7218 0.278264Z"
                fill="#0066FF" />
            </svg>
            <span class="text">Valuation Insights</span>
          </li>
          <li class="itemlist">
            <svg width="19" height="14" viewBox="0 0 19 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M18.7218 0.278264C18.3508 -0.0927548 17.7493 -0.0927548 17.3782 0.278264L5.99666 11.66L1.62177 7.28506C1.25079 6.91404 0.64932 6.91408 0.278264 7.28506C-0.0927548 7.65604 -0.0927548 8.25751 0.278264 8.62853L5.32491 13.6751C5.69578 14.0461 6.29769 14.0458 6.66842 13.6751L18.7218 1.62177C19.0928 1.25079 19.0927 0.649283 18.7218 0.278264Z"
                fill="#0066FF" />
            </svg>
            <span class="text">Investments & Acquisitions</span>
          </li>
          <li class="itemlist">
            <svg width="19" height="14" viewBox="0 0 19 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M18.7218 0.278264C18.3508 -0.0927548 17.7493 -0.0927548 17.3782 0.278264L5.99666 11.66L1.62177 7.28506C1.25079 6.91404 0.64932 6.91408 0.278264 7.28506C-0.0927548 7.65604 -0.0927548 8.25751 0.278264 8.62853L5.32491 13.6751C5.69578 14.0461 6.29769 14.0458 6.66842 13.6751L18.7218 1.62177C19.0928 1.25079 19.0927 0.649283 18.7218 0.278264Z"
                fill="#0066FF" />
            </svg>
            <span class="text">Annual Financial Performance</span>
          </li>
          <li class="itemlist">
            <svg width="19" height="14" viewBox="0 0 19 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M18.7218 0.278264C18.3508 -0.0927548 17.7493 -0.0927548 17.3782 0.278264L5.99666 11.66L1.62177 7.28506C1.25079 6.91404 0.64932 6.91408 0.278264 7.28506C-0.0927548 7.65604 -0.0927548 8.25751 0.278264 8.62853L5.32491 13.6751C5.69578 14.0461 6.29769 14.0458 6.66842 13.6751L18.7218 1.62177C19.0928 1.25079 19.0927 0.649283 18.7218 0.278264Z"
                fill="#0066FF" />
            </svg>
            <span class="text">Ratios Analysis</span>
          </li>
          <li class="itemlist">
            <svg width="19" height="14" viewBox="0 0 19 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M18.7218 0.278264C18.3508 -0.0927548 17.7493 -0.0927548 17.3782 0.278264L5.99666 11.66L1.62177 7.28506C1.25079 6.91404 0.64932 6.91408 0.278264 7.28506C-0.0927548 7.65604 -0.0927548 8.25751 0.278264 8.62853L5.32491 13.6751C5.69578 14.0461 6.29769 14.0458 6.66842 13.6751L18.7218 1.62177C19.0928 1.25079 19.0927 0.649283 18.7218 0.278264Z"
                fill="#0066FF" />
            </svg>
            <span class="text">Revenue and Expenditure Streams</span>
          </li>
          <li class="itemlist">
            <svg width="19" height="14" viewBox="0 0 19 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M18.7218 0.278264C18.3508 -0.0927548 17.7493 -0.0927548 17.3782 0.278264L5.99666 11.66L1.62177 7.28506C1.25079 6.91404 0.64932 6.91408 0.278264 7.28506C-0.0927548 7.65604 -0.0927548 8.25751 0.278264 8.62853L5.32491 13.6751C5.69578 14.0461 6.29769 14.0458 6.66842 13.6751L18.7218 1.62177C19.0928 1.25079 19.0927 0.649283 18.7218 0.278264Z"
                fill="#0066FF" />
            </svg>
            <span class="text">Shareholding Structures</span>
          </li>
          <li class="itemlist">
            <svg width="19" height="14" viewBox="0 0 19 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M18.7218 0.278264C18.3508 -0.0927548 17.7493 -0.0927548 17.3782 0.278264L5.99666 11.66L1.62177 7.28506C1.25079 6.91404 0.64932 6.91408 0.278264 7.28506C-0.0927548 7.65604 -0.0927548 8.25751 0.278264 8.62853L5.32491 13.6751C5.69578 14.0461 6.29769 14.0458 6.66842 13.6751L18.7218 1.62177C19.0928 1.25079 19.0927 0.649283 18.7218 0.278264Z"
                fill="#0066FF" />
            </svg>
            <span class="text">Insightful data-backed Report</span>
          </li>
        </ul>
      </div>
    </div>
    <div class="col-12 col-md-7">
      <div class="innerWrap">
        <h4 class="form-heading">
          The company is currently not in our records. Please fill out the form
          below with your requirements, and we'll aim to provide complete
          company details within 2-3 business hours.
        </h4>
      </div>
    </div>
  </div> -->
</div>
<div *ngIf="page == 2" class="wrap-submitmsg">
  <img src="assets/images/success.gif" class="submit-img" />
  <h3>Request submitted successfully!</h3>
  <p>we'll update you within 2-3 hours</p>
  <button type="submit" class="btn btn-outline-light btn-dark-blue-bg submit-button" [routerLink]="['/']">
    Go back to home
  </button>
  <button type="submit" class="btn btn-outline-light btn-grey-bg submit-button" [routerLink]="['/company/search']">
    Explore more companies
  </button>
</div>
